export const keyValueFormattedValidationError = (
  kvObjectGetter: (body: any) => Record<string, string>
) => (body: any): Error =>
  new Error(
    Object.entries(kvObjectGetter(body)).reduce(
      (s, [field, message]) => `${s}${field}: ${message}\n`,
      ''
    )
  )
